import {FeatureVariantAssignment} from '@udemy/graphql';
import {useFeatures} from '@udemy/react-experimentation-provider';

import {SHOW_AT_RISK_FEEDBACK_SURVEY} from 'src/lib/experimentation-constants';

export function useShowAtRiskSurveyFeature(): {
    isLoading: boolean;
    assignment: FeatureVariantAssignment | undefined;
} {
    const {featureVariantAssignments, isLoading} = useFeatures([SHOW_AT_RISK_FEEDBACK_SURVEY]);
    const assignment = featureVariantAssignments.get(SHOW_AT_RISK_FEEDBACK_SURVEY);

    return {
        isLoading,
        assignment,
    };
}
